module.exports = __webpack_public_path__ + "static/media/kh.add3236a.svg";